import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataWarehouseService } from '../../../core/services';
import { BehaviorSubject } from 'rxjs';
import { PageRequestModel } from '../../../core/models/PageRequestModel';

@Component({
  selector: 'brd-add-association-modal',
  templateUrl: './add-association-modal.component.html',
  styleUrls: ['./add-association-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddAssociationModalComponent implements OnInit {
  listMetadata: any;
  parent: { entityKey: string; key: string };
  items = new BehaviorSubject<any[]>([]);
  loading = new BehaviorSubject<boolean>(false);
  totalCount = new BehaviorSubject<number>(0);
  canAssociate = true;
  
  constructor(public dialogRef: MatDialogRef<AddAssociationModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private dataWarehouseService: DataWarehouseService) {
    this.listMetadata = data.metadata;
    this.parent = data.parent;
  }

  ngOnInit() {}

  onPageRequest(pageRequest: PageRequestModel) {
    this.loading.next(true);
    this.dataWarehouseService
      .getWarehouseList(
        this.listMetadata.classMetadataItems.entityKey,
        this.parent ? this.parent.entityKey : null,
        this.parent ? this.parent.key : null,
        pageRequest.page,
        pageRequest.pageSize,
        pageRequest.sort,
        pageRequest.sortDirection,
        pageRequest.searchTerm,
        this.dataWarehouseService.currentSubmittingEntityKey,
        false,
      )
      .take(1)
      .subscribe(r => {
        // TODO: handle errors
        this.loading.next(false);
        if (!r.hasError) {
          this.items.next(r.items);
          this.totalCount.next(r.totalCount);
        }
      });
  }

  onItemSelected(item: any) {
    this.dialogRef.close({ selected: item });
  }

  onItemAssociated(item: any){
    this.dialogRef.close({ associated: item });
  }

  add() {
    this.dialogRef.close({ add: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/components/add-association-modal/add-association-modal.component.ts